import { useMemo } from 'react';
import { useClientsQuery } from '@/features/Clients/Data';
import { useEquipamentosQuery, useNomesColaboradores } from '../hooks/data';
import AtivoDrawer from '../pages/EquipamentosListPage/components/Ativos/AtivoDrawer';
import type { ContextoAtivos } from '../pages/EquipamentosListPage/components/Ativos/ativos.utils';
import type { FormFichaAtivo } from '../pages/EquipamentosListPage/components/Ativos/ativoFicha.form';

interface CadastrarAtivoDrawerProps {
  isOpen: boolean;
  /** Já preenchido com o que foi digitado na busca (patrimônio, série, modelo, tipo). */
  inicial: Partial<FormFichaAtivo>;
  onClose: () => void;
  /** Cadastro salvo — ou, se a ficha achou um duplicado, o cadastro que já existia. */
  onPronto: (equipamentoId: string) => void;
}

/** A mesma ficha de "Novo ativo" do Inventário, aberta de fora (Movimentação, Estadia) pelo
 * "Ativo não encontrado — cadastrar agora?". */
export default function CadastrarAtivoDrawer({ isOpen, inicial, onClose, onPronto }: CadastrarAtivoDrawerProps) {
  const { data: ativos } = useEquipamentosQuery();
  const { data: clientes = [] } = useClientsQuery();
  const nomeColaboradorPorId = useNomesColaboradores();
  const contexto = useMemo<ContextoAtivos>(
    () => ({
      nomeClientePorId: new Map(clientes.map((c) => [c.id, c.name])),
      nomeColaboradorPorId,
    }),
    [clientes, nomeColaboradorPorId]
  );

  return (
    <AtivoDrawer
      aberto={isOpen ? 'novo' : null}
      ativos={ativos}
      inicialNovo={inicial}
      pendenciasPorId={new Map()}
      contexto={contexto}
      onAbrir={onPronto}
      onClose={onClose}
    />
  );
}
